import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { InterventionTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  InterventionTypeCreateDto,
  InterventionTypeDto,
  InterventionTypeExcelDownloadDto,
  InterventionTypeUpdateDto,
} from '../proxy/planning/dtos/intervention-type';
import { INTERVENTIONTYPE_CONFIG, INTERVENTIONTYPE_FIELDS } from './intervention-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-intervention-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, InterventionTypeService, ConfirmationService],
  templateUrl: './intervention-type.html',
  styleUrl: './intervention-type.scss',
})
export class InterventionType extends BaseCrudComponent<
  InterventionTypeDto,
  InterventionTypeCreateDto,
  InterventionTypeUpdateDto,
  InterventionTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(InterventionTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('InterventionType', ids),
  };
  config = INTERVENTIONTYPE_CONFIG;
  fields = INTERVENTIONTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: InterventionTypeDto): InterventionTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      shouldValidateInventory: data.shouldValidateInventory,
      shouldCreateNewRotation: data.shouldCreateNewRotation,
      shouldCheckStumpApplication: data.shouldCheckStumpApplication,
      shouldCheckApplyFeller: data.shouldCheckApplyFeller,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'InterventionType';
  }
}
